/**
 * Website Visit Handoff tracking helpers.
 * See the "Website Visit Handoff" integration contract for correlation_id /
 * anonymous_id semantics.
 */
import { getCookie, setCookie } from "./cookieStorage";

const CORRELATION_ID_COOKIE = "visit_correlation_id";
const CORRELATION_ID_EXPIRY_DAYS = 0.25; // 6 hours

const ANONYMOUS_ID_COOKIE = "visit_anonymous_id";
const ANONYMOUS_ID_EXPIRY_DAYS = 365 * 100; // effectively permanent

const generateId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Unique per click — a fresh id is minted only when none is cached; the
 * cookie is refreshed with a 6h expiry every time it's read so an active
 * browsing session keeps the same id.
 */
export const getOrCreateCorrelationId = () => {
  let id = getCookie(CORRELATION_ID_COOKIE);
  if (!id) {
    id = generateId();
  }
  setCookie(CORRELATION_ID_COOKIE, id, CORRELATION_ID_EXPIRY_DAYS);
  return id;
};

/**
 * Same for every click from one browser — generated once and never rotated.
 */
export const getOrCreateAnonymousId = () => {
  let id = getCookie(ANONYMOUS_ID_COOKIE);
  if (!id) {
    id = generateId();
    setCookie(ANONYMOUS_ID_COOKIE, id, ANONYMOUS_ID_EXPIRY_DAYS);
  }
  return id;
};
